import { QueryClient } from '@tanstack/react-query';
import { isApiError } from './client';

/** Human-readable message for any thrown value. Never leaks stack traces. */
export function errorMessage(error: unknown, fallback = 'Something went wrong. Please try again.'): string {
  if (isApiError(error)) {
    return error.message;
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return fallback;
}

/**
 * Server data is cached briefly and refetched after mutations (invalidate by query key).
 * 4xx responses are not retried: they will not succeed on a second attempt.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => isApiError(error) && error.isRetryable && failureCount < 2,
      },
      mutations: { retry: false },
    },
  });
}
